export default {
  pushOnClick: (scene, button, callback) => {
    const sndClick = scene.sound.add("snd-click", {
      volume: 0.5,
    });
    sndClick.play();

    button.disableInteractive();
    scene.scene.scene.add.tween({
      targets: button,
      scaleX: "*=0.8",
      scaleY: "*=0.8",
      duration: 80,
      yoyo: true,
      onComplete: () => {
        button.setInteractive();
        callback();
      },
    });
  },

  releaseOnClick: (scene, button) => {
    scene.scene.scene.add.tween({
      targets: button,
      scaleX: "/=0.8",
      scaleY: "/=0.8",
      duration: 80,
    });
  },

  enableInteraction: (buttons) => {
    buttons.forEach((button) => {
      button.setInteractive();
    });
  },

  disableInteraction: (buttons) => {
    buttons.forEach((button) => {
      button.disableInteractive();
    });
  },
};
